import React from "react";

import { Button, DatePicker, Input, Select } from "../../components";
import { Globals } from "../../utils";
import moment from "moment";

class Filter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        user_id: Globals.getUserId(props.user),
        search: '',
        init_date: '',
        end_date: '',
      },
      dates: {
        minDate: "",
        maxDate: ""
      },
      countryEquivalent: Globals.getUserCountryEquivalent(),
      searchTimeout: null,
    };
  }

  componentWillUnmount() {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  autoFilter = (isText = false) => {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
    if (isText) {
      const searchTimeout = setTimeout(() => {
        this.submitForm();
      }, 700);
      this.setState({ searchTimeout });
    } else {
      this.submitForm();
    }
  };

  submitForm = () => {
    const { form } = this.state;
    const init_date = form.init_date ? moment(form.init_date).format('YYYY-MM-DD') : '';
    const end_date = form.end_date ? moment(form.end_date).format('YYYY-MM-DD') : '';
    this.props.submitted({ ...form, init_date, end_date });
  };

  handleChange = (emitter, string) => {
    let { name, value, type } = emitter.target;
    const isText = !['select-one', 'select-multiple', 'checkbox', 'radio'].includes(type);

    this.setState(state => ({
      form: {
        ...state.form,
        [name]: value
      }
    }), () => {
      this.autoFilter(isText);
    });
  };

  onSubmit = (emitter) => {
    emitter.preventDefault();
    this.submitForm();
  }

  render() {

    const { form, dates } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <div className="row">
          <div className="col-md">
            <Input
              color=" "
              name="search"
              label="Búsqueda"
              className="filter"
              onChange={this.handleChange}
              value={form.search}
              placeholder={`Buscar por Nombre, Email, ${ this.state.countryEquivalent.bothDni } o Código de caja`}
            />
          </div>

          <div className="col-md">
            <DatePicker
              color="white"
              label="Desde"
              className="filter"
              minDate={dates.minDate}
              value={form.init_date}
              onChange={value => {
                this.setState(state => ({
                  form: {
                    ...state.form,
                    init_date: value
                  }
                }), () => this.autoFilter(false));
              }}
            />
          </div>

          <div className="col-md">
            <DatePicker
              color="white"
              label="Hasta"
              className="filter"
              maxDate={dates.maxDate}
              value={form.end_date}
              onChange={value => {
                this.setState(state => ({
                  form: {
                    ...state.form,
                    end_date: value
                  }
                }), () => this.autoFilter(false));
              }}
            />
          </div>
        </div>
      </form>
    );
  }
}

export default Filter;
